const SDK_VERSION = '8.12.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
